(function() {
  define('tlhComponentsModalConfirm',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsModalConfirm', []).component('tlhModalConfirm', {
      template: '<ng-transclude ng-click="$ctrl.openModal()"></ng-transclude>',
      transclude: true,
      bindings: {
        message: '@',
        redirectTo: '@'
      },
      controller: [
        '$window', 'TlhConfirmModalService', function($window, TlhConfirmModalService) {
          var vm;
          vm = this;
          vm.openModal = function() {
            var message;
            message = '<p class="text-center">' + vm.message + '</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return $window.location.href = vm.redirectTo;
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=modalConfirm.js.map
;
